import { useEffect, useState } from "react";

import {
  readIncidentCustomerName,
  resolveIncidentCustomerName,
  type IncidentCustomerSource,
} from "./customerLabel";

export function useIncidentCustomerName(incident: IncidentCustomerSource | null | undefined): string | null {
  const [name, setName] = useState<string | null>(() => readIncidentCustomerName(incident) ?? null);

  useEffect(() => {
    const immediate = readIncidentCustomerName(incident);
    if (immediate && incident?.customer?.name?.trim()) {
      setName(immediate);
      return;
    }

    if (!incident) {
      setName(null);
      return;
    }

    if (immediate) {
      setName(immediate);
    }

    let cancelled = false;
    void resolveIncidentCustomerName(incident).then((resolved) => {
      if (!cancelled && resolved) {
        setName(resolved);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [
    incident,
    incident?.customer?.id,
    incident?.customer?.name,
    incident?.customerId,
    incident?.sourceSystemId,
    incident?.sourceSystem?.id,
  ]);

  return name;
}
